import TickerPrice from './TickerPrice';

export default TickerPrice;
